<template>
  <div>
    <div class="row justify-content-center">
      <a v-bind:href="downloadLink" id="download_link" class="btn-lg btn btn-default ripple-parent">Download
        <font-awesome-icon icon="file-download" :class="iconClass"></font-awesome-icon>
  </a>
      <mdb-btn class="btn-lg" v-on:click="showKindleForm">Email to Kindle
        <font-awesome-icon :icon="['far', 'envelope']" :class="iconClass"></font-awesome-icon>
      </mdb-btn>
    </div>

    <form role="form" id="email_form" :class="['mt-md-4', 'mb-md-5', isFormClicked ? 'visible': 'invisible']"
          @submit.prevent="emailToKindle" autocomplete="off">
      <div class="form-row justify-content-center">
        <Column md="4">
          <mdb-input type="email" id="kindle_email_address" autocomplete="off" aria-describedby="kindleEmailHelpBlock"
                     v-model="kindleEmailAddress" label="Kindle Email Address" required/>
          <small id="kindleEmailHelpBlock" class="form-text text-muted">
            Please ensure that you add our email address testemailserver123@gmail.com to your device's approved email
            list
          </small>
        </Column>
        <!-- 1.0 to get it on one line haha-->
        <Column md="1.0">
          <mdb-btn type="submit" class="mt-md-3" color="pink" :disabled="emailInProgress">Send
            <font-awesome-icon :icon="['far', 'envelope']" :hidden="emailInProgress || emailCompleted"
                               :class="iconClass"></font-awesome-icon>
            <font-awesome-icon icon="spinner" spin :hidden="!emailInProgress" :class="iconClass"></font-awesome-icon>
            <font-awesome-icon icon="check" :hidden="!emailCompleted" :class="iconClass"></font-awesome-icon>
          </mdb-btn>
        </Column>
      </div>

    </form>

    <div class="row">
      <div class="col-md-12 text-right">
        <mdb-btn @click="newBook" outline="default">
      New
          <font-awesome-icon icon="redo" :class="iconClass"></font-awesome-icon>
        </mdb-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {Column, mdbBtn, mdbInput} from 'mdbvue'

import {library} from '@fortawesome/fontawesome-svg-core'
import {faCheck, faFileDownload, faRedo, faSpinner} from '@fortawesome/free-solid-svg-icons'
import {faEnvelope} from '@fortawesome/free-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(faSpinner)
library.add(faCheck)
library.add(faRedo)
library.add(faEnvelope)
library.add(faFileDownload)
Vue.component('font-awesome-icon', FontAwesomeIcon)

export default {
  name: 'Download',
  components: {
    mdbInput,
    Column,
    mdbBtn
  },
  data() {
    return {
      downloadLink: process.env.API_URL + '/download/' + this.$sessionStorage.get("jobId", "Job Id not present"),
      kindleEmailAddress: '',
      jobId: this.$sessionStorage.get("jobId", "Job Id not present"),
      emailInProgress: false,
      emailCompleted: false,
      isFormClicked: false,
      iconClass: {
        "ml-md-1": true
      }
    }
  },
  methods: {
    emailToKindle () {
      this.emailInProgress = true
      this.emailCompleted = false
      this.$http.post('/email', {kindleEmailAddress: this.kindleEmailAddress, jobId: this.jobId})
        .then(() => {
          this.emailInProgress = false
          this.emailCompleted = true
        })
        .catch(() => {
          alert('Unfortunately, something went wrong')
          this.emailInProgress = false
          this.emailCompleted = false
        })
    },
    newBook () {
      this.$http.delete('/previous-book', {data: {jobId: this.jobId}})
        .catch(() => alert('Unfortunately, something went wrong'))
      this.$router.replace('/')
    },
    showKindleForm () {
      this.isFormClicked = !this.isFormClicked
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Download.vue